import i18n from 'i18next';
import React, { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { fetchUserGuide } from '../common/agents/userGuideAgents';
import { supportEmailAddress } from '../constant';
import LayoutPage from '../layout/LayoutPage';
import LoadingIndicator from '../layout/loading/LoadingIndicator';

// The link's language, not the UI language, decides both the guide and the message.
const toLinkLanguage = (search) => (new URLSearchParams(search).get('lang') === 'fr' ? 'fr' : 'en');

const UserGuidePage = () => {
  const { search } = useLocation();
  const language = toLinkLanguage(search);
  const [isUnavailable, setIsUnavailable] = useState(false);
  const [guideUrl, setGuideUrl] = useState(null);

  useEffect(() => {
    // The page can unmount mid-download (e.g. a 503 sends MyRoute to /maintenance): a late result must not navigate away from there.
    let cancelled = false;
    fetchUserGuide(language)
      .then((response) => {
        if (cancelled) return;
        const url = URL.createObjectURL(response.data);
        // Kept for the fallback link: the tab stays here when the browser downloads the PDF instead of showing it.
        setGuideUrl(url);
        window.location.replace(url);
      })
      .catch(() => {
        if (!cancelled) setIsUnavailable(true);
      });
    return () => {
      cancelled = true;
    };
  }, [language]);

  if (!guideUrl && !isUnavailable) return <LoadingIndicator />;

  // In the portal layout so its menu leads back to the portal from the fallback link or the unavailable message
  return (
    <LayoutPage>
      <p className="p-5">
        {guideUrl ? (
          <a href={guideUrl}>{i18n.getFixedT(language, 'userGuide')('openGuide')}</a>
        ) : (
          <Trans
            i18n={i18n}
            t={i18n.getFixedT(language, 'userGuide')}
            i18nKey="unavailable"
            values={{ email: supportEmailAddress }}
            components={{ emailLink: <a href={`mailto:${supportEmailAddress}`}>{supportEmailAddress}</a> }}
          />
        )}
      </p>
    </LayoutPage>
  );
};

export default UserGuidePage;
